// Adapted from apps/admin/src/pages/dashboard/gps-tracking/components/playback-info.tsx (PRD #875): labels go through i18n.
import React from "react";
import { formatTimelineTime } from "@racoon/ui";
import { cn } from "@racoon/ui";
import { useT, Namespace } from "@racoon/i18n";

interface PlaybackInfoProps {
  currentTime: number | null;
  lat?: number;
  lon?: number;
  speed?: number;
  angle?: number;
  className?: string;
}

export function PlaybackInfo({ currentTime, lat, lon, speed, className }: PlaybackInfoProps) {
  const t = useT();

  if (currentTime === null) return null;

  return (
    <div
      data-testid="gps-tracking-playback-info"
      className={cn(
        "grid grid-cols-4 gap-2 text-xs bg-white border rounded-lg p-3 w-[25rem]",
        className,
      )}
    >
      <div className="flex flex-col gap-1">
        <div className="text-muted-foreground font-medium">
          {t(Namespace.GpsTracking, "playbackTime")}
        </div>
        <div className="font-mono font-semibold text-sm">{formatTimelineTime(currentTime)}</div>
      </div>
      <div className="flex flex-col gap-1">
        <div className="text-muted-foreground font-medium">
          {t(Namespace.GpsTracking, "playbackSpeed")}
        </div>
        <div className="font-mono font-semibold text-sm ">
          {speed !== undefined
            ? `${speed.toFixed(1)} ${t(Namespace.GpsTracking, "gpsStopSpeedUnit")}`
            : "—"}
        </div>
      </div>
      <div className="flex flex-col gap-1">
        <div className="text-muted-foreground font-medium">
          {t(Namespace.GpsTracking, "playbackLatitude")}
        </div>
        <div className="font-mono font-semibold text-sm ">
          {lat !== undefined ? lat.toFixed(6) : "—"}
        </div>
      </div>
      <div className="flex flex-col gap-1">
        <div className="text-muted-foreground font-medium">
          {t(Namespace.GpsTracking, "playbackLongitude")}
        </div>
        <div className="font-mono font-semibold text-sm ">
          {lon !== undefined ? lon.toFixed(6) : "—"}
        </div>
      </div>
    </div>
  );
}
